import React, { useState, useEffect } from "react";
import { useAppDispatch } from "../../common/hooks/hooks";
import { toggleSettingsPopup } from "./SettingsPopup/settingsPopupSlice";
import Icon from "../../common/components/Icon/Icon";

const FixedActionsRight: React.FC = () => {
  const dispatch = useAppDispatch();
  const [isScrollTopVisible, setIsScrollTopVisible] = useState(false);

  useEffect(() => {
    const scrollThreshold = 400;
    const toggleVisibility = () => {
      setIsScrollTopVisible(window.scrollY > scrollThreshold);
    };

    toggleVisibility(); // Initial check
    window.addEventListener("scroll", toggleVisibility, { passive: true });
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleToggleSettings = () => {
    dispatch(toggleSettingsPopup());
  };

  return (
    <div className="fixed-actions-right">
      {/* Scroll to Top Button */}
      <button
        className={`scroll-to-top ${isScrollTopVisible ? "is-visible" : ""}`}
        aria-label="Scroll to top"
        onClick={scrollToTop}
      >
        <Icon iconName="arrow-up" />
      </button>

      {/* Settings Popup Toggler Wrapper */}
      <div className="fixed-actions-right__settings-popup-toggler">
        <button
          className="settings-toggle"
          aria-label="Open settings"
          aria-controls="settings-popup"
          onClick={handleToggleSettings}
          data-settings-toggle
        >
          <Icon iconName="cog-filled" className="icon--filled" />
        </button>
      </div>
    </div>
  );
};

export default FixedActionsRight;
